import { useState } from "react"

import Modal from '../../../../../shared/modal/Modal'
import FormLayout from "../../../../../shared/components/FormLayout/FormLayout"
import FormSection from "../../../../../shared/components/FormLayout/FormSection"
import Button from "../../../../../shared/components/Button/Button"
import Input from "../../../../../shared/components/form/input"
import SimpleProduct from "../../../../SimpleProduct/SimpleProduct"

/* Hooks */
import useFlashMessage from '../../../../../hooks/useFlashMessage'

import NumberToMoney from "../../../../../shared/functions/NumberToMoney"

import { FaBoxOpen, FaCheckCircle, FaBarcode, FaRuler } from "react-icons/fa"
import { FaMoneyBillWave } from "react-icons/fa6"

import './FormBudgetItem.css'
import './FormBudgetSimpleItem.css'

function FormBudgetSimpleItem({ handleSubmit, handleOnSuccess, itemData, btCancelAction, title, btnText, btnVariant }) {

    const [item, setItem] = useState(itemData || { totalQuantity: 0 })
    const [selectedItem, setSelectedItem] = useState(itemData || {})
    const [pickerProduct, setPickerProduct] = useState(null)
    const [modalSelectProduct, setModalSelectProduct] = useState(false)
    const { setFlashMessage } = useFlashMessage()

    const productSelected = !!selectedItem._id

    function handleChange(e) {
        setItem({ ...item, [e.target.name]: e.target.value })
    }

    const submit = () => {
        if (!selectedItem._id) {
            setFlashMessage("Selecione um produto ", 'error')
            return
        }

        if (!item.totalQuantity || parseInt(item.totalQuantity) === 0) {
            setFlashMessage("Selecione uma quantidade minima", 'error')
            return
        }

        let data = selectedItem
        data = { ...data, discountValue: 0, totalInCash: NumberToMoney(item.totalQuantity * parseFloat(selectedItem.totalInCash)), totalInstalment: NumberToMoney(item.totalQuantity * parseFloat(selectedItem.totalInstalment)) }
        data = { ...item, ...data }

        handleSubmit(data)
        handleOnSuccess()
    }

    return (
        <FormLayout
            title={title}
            actions={
                <>
                    <Button variant={btnVariant || 'save'} onClick={submit}>{btnText || 'Salvar'}</Button>
                    {btCancelAction && <Button variant="cancel" onClick={btCancelAction}>Cancelar</Button>}
                </>
            }
        >
            <FormSection label="Produto">
                <button type="button" className="budget-select-btn" onClick={() => setModalSelectProduct(true)}>
                    <FaBoxOpen size={16} /><span>Selecionar Produto</span>
                </button>

                <Modal
                    modalStatus={modalSelectProduct}
                    changeStatus={setModalSelectProduct}
                    w={90}
                    t={2}
                    content={
                        <SimpleProduct
                            enableSelectRow={true}
                            itemData={pickerProduct}
                            handleOnSelected={(i) => setPickerProduct(i)}
                            onFinishSelect={() => { if (pickerProduct) { setSelectedItem(pickerProduct); setModalSelectProduct(false) } }}
                        />
                    }
                />

                {productSelected ? (
                    <div className="bspc">
                        <div className="bspc-badge"><FaCheckCircle size={11} /><span>Produto selecionado</span></div>
                        <div className="bspc-content">
                            <div className="bspc-header">
                                <span className="bspc-title">{selectedItem.description}</span>
                                <span className="bspc-code">#{selectedItem.code}</span>
                            </div>
                            <div className="bspc-grid">
                                {selectedItem.unit?.label && (
                                    <div className="bspc-field"><FaRuler className="bspc-icon" size={13} /><span>{selectedItem.unit.label}</span></div>
                                )}
                                {selectedItem.ncm && (
                                    <div className="bspc-field"><FaBarcode className="bspc-icon" size={13} /><span>{selectedItem.ncm}</span></div>
                                )}
                            </div>
                            {(selectedItem.totalInCash || selectedItem.totalInstalment) && (
                                <div className="bspc-price-row">
                                    {selectedItem.totalInCash && (
                                        <div className="bspc-price"><FaMoneyBillWave size={13} />R$ {selectedItem.totalInCash} à vista</div>
                                    )}
                                    {selectedItem.totalInstalment && (
                                        <div className="bspc-price"><FaMoneyBillWave size={13} />R$ {selectedItem.totalInstalment} parcelado</div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                ) : (
                    <div className="bspc-empty">
                        <FaBoxOpen size={16} />
                        <span>Nenhum produto selecionado ainda.</span>
                    </div>
                )}
            </FormSection>

            <FormSection label="Quantidade e Totais">
                <div className="fl-row">
                    <div className="fl-col-narrow form-group">
                        <Input
                            text="Quantidade"
                            type="number"
                            name="totalQuantity"
                            handleOnChange={handleChange}
                            value={item.totalQuantity || 0}
                        />
                    </div>
                </div>

                <div className="fbsi-totals">
                    <div className="fbsi-total-tile">
                        <span className="fbsi-total-label">Total à vista</span>
                        <span className="fbsi-total-value">R$ {NumberToMoney(item.totalQuantity * parseFloat(selectedItem.totalInCash))}</span>
                    </div>
                    <div className="fbsi-total-tile">
                        <span className="fbsi-total-label">Total parcelado</span>
                        <span className="fbsi-total-value">R$ {NumberToMoney(item.totalQuantity * parseFloat(selectedItem.totalInstalment))}</span>
                    </div>
                </div>
            </FormSection>
        </FormLayout>
    )
}

export default FormBudgetSimpleItem
